import { render, staticRenderFns } from "./CardCadastroProdutorFazenda.vue?vue&type=template&id=4161f1fe"
import script from "./CardCadastroProdutorFazenda.vue?vue&type=script&lang=js"
export * from "./CardCadastroProdutorFazenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports